import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import db from "../../../../api/mongodb";
// import * as Survey from "survey-react";
import { Survey } from "survey-react-ui";
import { Model, StylesManager } from "survey-core";
import "survey-react/modern.css";
import { Container, Row, Col, Image } from "react-bootstrap";
import { defaultOptions1 } from "../../../../config/loading-config.js";
import Lottie from "react-lottie";
import "./SafeAPRegistrationDetails.scss";
import { Button } from "react-bootstrap";

// Survey.StylesManager.applyTheme("modern");
StylesManager.applyTheme("modern");

const SafeAPRegistrationDetails = (props) => {
    const [isLoading, setIsLoading] = useState(true);
    //   const [surveyModel, setSurveyModel] = useState(new Survey.Model({}));
    const [surveyModel, setSurveyModel] = useState(new Model({}));
    const { id } = useParams();

    useEffect(() => {
        loadSurvey();
    }, []);

    const loadSurvey = () => {
        // const survey = new Survey.Model();
        const survey = new Model({});
        survey.completeText = "Save";
        survey.completedHtml = "Changes saved!";

        db.get("/api/courses", {
            headers: {
                Authorization: `${localStorage.getItem("token")}`,
            },
        }).then(
            (response) => {
                var mappedTitles = {};
                var choices = [];
                response.data.forEach((entry) => {
                    mappedTitles[entry.name] = entry._id;
                    choices.push(entry.name);
                });

                db.get("/api/safeAPTemplates", {
                    headers: {
                        Authorization: `${localStorage.getItem("token")}`,
                    },
                }).then(
                    (response) => {
                        var template = response.data[0].surveyTemplate;
                        // template.elements[0].elements[1].columns[0].choices = choices;

                        // template.elements[0].elements[0].elements[9] = {};
                        // template.elements[0].elements[0].elements[10] = {};
                        // template.elements[0].elements[3] = {}

                        const survey = new Model(template);

                        var passwordQuestion = survey.getQuestionByName("password");
                        var confirmPasswordQuestion = survey.getQuestionByName("confirmPassword")
                        var tcQuestion = survey.getQuestionByName("termsAndConditions")
                        var emailQuestion = survey.getQuestionByName("email")

                        passwordQuestion.parent.removeQuestion(passwordQuestion)
                        confirmPasswordQuestion.parent.removeQuestion(confirmPasswordQuestion)
                        tcQuestion.parent.removeQuestion(tcQuestion)
                        emailQuestion.parent.removeQuestion(emailQuestion)
                        // survey.showNavigationButtons = false;
                        // survey.showCompletedPage = false;
                        // survey.mode = "display";
                        survey.completeText = "Save";

                        db.get(`/api/safeAPs/${id}`, {
                            headers: {
                                Authorization: `${localStorage.getItem("token")}`,
                            },
                        }).then(
                            (response) => {
                                survey.data = {
                                    ...response.data.formData,
                                    // img: response.data.profileImg,
                                    // courses: response.data.courses,
                                    // resume: response.data.resume,
                                };

                                setSurveyModel(survey);
                                setIsLoading(false);
                            },
                            (error) => { }
                        );

                        survey.onComplete.add(function (sender, options) {
                            console.log(sender.data)



                            // const registration = new Date().toISOString();
                            // const clientQuestionnaire =
                            //   answers.clientQuestionnaire &&
                            //   new Date(answers.clientQuestionnaire).toISOString();
                            // const neighborhoodSurvey =
                            //   answers.neighborhoodSurvey &&
                            //   new Date(answers.neighborhoodSurvey).toISOString();
                            // const propertyAssessment =
                            //   answers.propertyAssessment &&
                            //   new Date(answers.propertyAssessment).toISOString();


                            db.put(`/api/safeAps/${id}`, {
                                formData: sender.data
                            }, {
                                headers: {
                                    Authorization: `${localStorage.getItem("token")}`,
                                },
                            }).then(
                                (response) => { },
                                (error) => { }
                            );
                        });
                    },
                    (error) => { }
                );
            },
            (error) => { }
        );
    };

    if (isLoading) {
        return <Lottie options={defaultOptions1} height={200} width={200} />;
    }

    return (
        <>
            <div className="project-grid">
                <div className="project-grid-header">
                    <h1 className="page-title">Edit Account Information</h1>
                    <div className="grid-list-icons">
                        <Link to={`/safeAPs/profile/${id}`}>
                            <Button className="btn-primary">Back</Button>
                        </Link>
                    </div>
                </div>
                <div className="create-project-container">
                    <Survey model={surveyModel} />
                </div>
            </div>
        </>
    );
};

export default SafeAPRegistrationDetails;
